import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import { FileTextIcon,
         PrinterIcon,
         AlertTriangleIcon,
         CircleIcon,
         ChevronDownIcon,
         CheckCircleIcon,
         ChevronUpIcon,
         UserIcon,
         DollarSignIcon,
         AlignCenterIcon,
         MapIcon,
         MousePointerIcon,
         LoaderIcon,
         PackageIcon,
         UnderlineIcon,
         MoveIcon,
         TagIcon,
         BookmarkIcon,
         AwardIcon
        } from 'vue-feather-icons'
import { sync } from 'vuex-router-sync'
import store from './store'
import './filters'
import 'vuetify/dist/vuetify.min.css'
import i18n from './i18n'
import { Closable } from '@/directives/closable.js'
import InstantSearch from 'vue-instantsearch'
// import UUID from 'vue-uuid'

// import "@fortawesome/fontawesome-free/css/all.css";
// import 'vue-googlemaps/dist/vue-googlemaps.css'
import * as VueGoogleMaps from 'vue2-google-maps'

// wrld global components
import WrldContainer from '@/components/wrld/WrldContainer'
import WrldBox from '@/components/wrld/WrldBox'
import WrldOverview from '@/components/wrld/WrldOverview'
import WrldOutOfBox from '@/components/wrld/WrldOutOfBox'
import WrldConfirmOnBtn from '@/components/wrld/WrldConfirmOnBtn'
import WrldOverlayLoader from '@/components/wrld/WrldOverlayLoader'

import AlgoliaSecuredSearch from '@/plugins/algolia-secured-search'

import apolloClient from '@/_services/apollo.service.js'
import VueApollo from 'vue-apollo'

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

import VueApexCharts from 'vue-apexcharts'

var apolloProvider = null

// Set your APP_ID for intercom
var APP_ID = "fx5x0kcb";

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://ce87e5b385d843a496f588899e93b566@sentry.io/1877424',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  })
}

// if (process.env.NODE_ENV === 'development') {
//   window.LOKALISE_CONFIG = {
//     projectId: "18302045592fa799a35d20.15846093",
//     locale: "en"
//   };
//   (function () {
//     var a = document.createElement("script");a.type = "text/javascript";a.async = !0;
//     a.src = ["https://app.lokalise.com/live-js/script.min.js?", (new Date).getTime()].join("");
//     document.body.appendChild(a)
//   })();
// }

if (process.env.VUE_APP_GRAPHQL_ENABLE) {
  // Use apollo globally
  Vue.use(VueApollo)
  apolloProvider = new VueApollo({
    defaultClient: apolloClient
  })
}

sync(store, router)
// Custom plugin to save per user API_KEY Algolia search
Vue.use(AlgoliaSecuredSearch, { store })

Vue.config.productionTip = false

Vue.use(InstantSearch)
// Vue.use(UUID)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCbHnQzn6E07DM6lBqgfPDj7Gp1u8WVpJY',
    libraries: 'places', // necessary for places input
    useBetaRenderer: false
  }
})

Vue.use(VueApexCharts)
window.Apex.chart = {
  locales: [{
    "name": "en",
    "options": {
      "months": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      "shortMonths": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      "days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      "shortDays": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      "toolbar": {
        "exportToSVG": "Download SVG",
        "exportToPNG": "Download PNG",
        "menu": "Menu",
        "selection": "Selection",
        "selectionZoom": "Selection Zoom",
        "zoomIn": "Zoom In",
        "zoomOut": "Zoom Out",
        "pan": "Panning",
        "reset": "Reset Zoom"
      }
    }
  },
  {
    "name": "cs",
    "options": {
      "months": ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"],
      "shortMonths": ["Led", "Úno", "Bře", "Dub", "Kvě", "Čvn", "Čvc", "Srp", "Zář", "Říj", "Lis", "Pro"],
      "days": ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"],
      "shortDays": ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],
      "toolbar": {
        "exportToSVG": "Stáhnout SVG",
        "exportToPNG": "Stáhnout PNG",
        "exportToCSV": "Stáhnout CSV",
        "menu": "Menu",
        "selection": "Vybrat",
        "selectionZoom": "Zoom: Vybrat",
        "zoomIn": "Zoom: Přiblížit",
        "zoomOut": "Zoom: Oddálit",
        "pan": "Přesouvat",
        "reset": "Resetovat"
      }
    }
  }
]
}
// Vue.use(Vuetify, {
//   options: {
//     customProperties: true
//   },
//   theme: {
//     primary: '#212121',
//     secondary: '#EEEEEE',
//     accent: '#FF5252',
//     primary_text: '#FFFFFF',
//     text: '212121',
//     secondary_text: '757575',
//     divider: 'BDBDBD',
//     kazan: '#267885',
//     kazan_light: '#7caeb5',
//     wrld_background: '#fafafa',
//     wrld_title: '#484848',
//     wrld_subtitle: '#767676',
//     wrld_grey: '#c5c5c5',
//     wrld_red: '#ff4a57'
//   }
// })
Vue.directive('closable', Closable)

// wrld global components
Vue.component('wrld-container', WrldContainer)
Vue.component('wrld-box', WrldBox)
Vue.component('wrld-overview', WrldOverview)
Vue.component('wrld-out-of-box', WrldOutOfBox)
Vue.component('wrld-confirm-btn', WrldConfirmOnBtn)
Vue.component('wrld-overlay-loader', WrldOverlayLoader)

// wrld feather icons
Vue.component('FileTextIcon', FileTextIcon)
Vue.component('PrinterIcon', PrinterIcon)
Vue.component('AlertTriangleIcon', AlertTriangleIcon)
Vue.component('CircleIcon', CircleIcon)
Vue.component('ChevronDownIcon', ChevronDownIcon)
Vue.component('ChevronUpIcon', ChevronUpIcon)
Vue.component('CheckCircleIcon', CheckCircleIcon)
Vue.component('UserIcon', UserIcon)
Vue.component('DollarSignIcon', DollarSignIcon)
Vue.component('AlignCenterIcon', AlignCenterIcon)
Vue.component('MapIcon', MapIcon)
Vue.component('MousePointerIcon', MousePointerIcon)
Vue.component('LoaderIcon', LoaderIcon)
Vue.component('PackageIcon', PackageIcon)
Vue.component('UnderlineIcon', UnderlineIcon)
Vue.component('MoveIcon', MoveIcon)
Vue.component('TagIcon', TagIcon)
Vue.component('BookmarkIcon', BookmarkIcon)
Vue.component('AwardIcon', AwardIcon)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  store: store,
  apolloProvider,
  i18n,
  vuetify,
  render: h => h(App)
})
